module.exports = __webpack_public_path__ + "static/media/polaroid-12.9c31b5b2.png";